import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RegionSelect from './RegionSelect';
import RackName from './RackName';

import RackCreationMethod from './RackCreationMethod';

const styles = {
  advancedSettings: {
    paddingLeft: 0,
    paddingY: 0
  }
};

VRackInfo.propTypes = {
  updateRack: PropTypes.func,
  updateRackName: PropTypes.func,
  setNextButtonDisabled: PropTypes.func,
  rack: PropTypes.object,
  rackName: PropTypes.string,
  selectedSnapshot: PropTypes.object,
  setSelectedSnapshot: PropTypes.func
};

export default function VRackInfo({
  rack,
  rackName,
  updateRack,
  updateRackName,
  setNextButtonDisabled,
  selectedSnapshot,
  setSelectedSnapshot
}) {
  const [isRackNameValid, setIsRackNameValid] = useState(false);
  const [isRegionValid, setIsRegionValid] = useState(false);
  const [isSelectedMethodValid, setIsSelectedMethodValid] = useState(false);

  const handleRackNameValidationChange = (isValid) => {
    setIsRackNameValid(isValid);
  };

  const handleRegionValidationChange = (isValid) => {
    setIsRegionValid(isValid);
  };

  const handleSelectedMethodValidation = (isValid) => {
    setIsSelectedMethodValid(isValid);
  };

  useEffect(() => {
    setNextButtonDisabled(!(isRackNameValid && isRegionValid && isSelectedMethodValid));
  }, [isRackNameValid, isRegionValid, isSelectedMethodValid, setNextButtonDisabled]);

  return (
    <Grid
      data-testid="vrack-info"
      container
      ml={0}
      spacing={2}
      rowSpacing={1.5}
      mt={1}
      mb={1}
      item
      xs={12}
    >
      <Grid item xs={12} sm={6} lg={4} mb={2}>
        <RackName
          rackName={rackName}
          updateRackName={updateRackName}
          handleRackNameValidationChange={handleRackNameValidationChange}
        />
      </Grid>
      <Grid container item sm={12}>
        <RegionSelect
          rack={rack}
          updateRack={updateRack}
          handleRegionValidationChange={handleRegionValidationChange}
        />
      </Grid>
      <Grid item sm={12}>
        <Accordion defaultExpanded sx={{ background: 'none' }}>
          <AccordionSummary sx={styles.advancedSettings} expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Rack Creation Method</Typography>
          </AccordionSummary>
          <AccordionDetails sx={styles.advancedSettings}>
            <RackCreationMethod
              rack={rack}
              updateRack={updateRack}
              selectedSnapshot={selectedSnapshot}
              setSelectedSnapshot={setSelectedSnapshot}
              handleSelectedMethodValidation={handleSelectedMethodValidation}
            />
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
}
